import dayjs from 'utils/dayjsSetup';
import { NonWorkingDay } from '../graphql/types';

function isNonWorkingDayOrWeekend(nonWorkingDays: NonWorkingDay[], date: Date) {
  const dayOfWeek = dayjs.utc(date).day();
  const currentDate = dayjs.utc(date).startOf('day');
  return nonWorkingDays.some((nwd) => dayjs.utc(nwd.date).startOf('day').isSame(currentDate, 'day')) || dayOfWeek === 0 || dayOfWeek === 6;
}

export function getBankingDatesBetween(nonWorkingDays: NonWorkingDay[], start: Date, end: Date) {
  const startDate = dayjs.utc(start).startOf('day');
  const endDate = dayjs.utc(end).startOf('day');
  let nonWorkingDayCount = 0;

  let currentDate = startDate;
  while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, 'day')) {
    if (isNonWorkingDayOrWeekend(nonWorkingDays, currentDate.toDate())) {
      nonWorkingDayCount++;
    }
    currentDate = currentDate.add(1, 'day');
  }

  const totalDays = endDate.diff(startDate, 'day') + 1;
  return totalDays - nonWorkingDayCount;
}

export function countNotPayingBankingDays(
  nonWorkingDays: NonWorkingDay[],
  lastPmtDay?: Date | null,
  startDate?: Date | null,
  endDate: Date = new Date()
): number | null {
  const from =
    lastPmtDay != null && dayjs.utc(lastPmtDay).isValid() ? lastPmtDay : startDate;
  if (from == null || !dayjs.utc(from).isValid()) return null;

  const fromDay = dayjs.utc(from).startOf('day');
  const endDay = dayjs.utc(endDate).startOf('day');
  if (fromDay.isSame(endDay, 'day')) return 0;

  const days = getBankingDatesBetween(nonWorkingDays, fromDay.toDate(), endDate);
  return days < 0 ? null : days;
}
